import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const API = axios.create({ baseURL: BASE });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['authorization'] = `Bearer ${token}`;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  login: (username, password) => API.post('/api/auth/login', { username, password }),
  me: () => API.get('/api/auth/me'),
  changePassword: (current_password, new_password) =>
    API.post('/api/auth/change-password', { current_password, new_password }),
};

export const clients = {
  list: (params) => API.get('/api/clients', { params }),
  create: (data) => API.post('/api/clients', data),
  update: (id, data) => API.put(`/api/clients/${id}`, data),
  uploadCSV: (office, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return API.post(`/api/clients/csv-upload?office=${office}`, fd);
  },
  template: () => API.get('/api/clients/csv-template', { responseType: 'blob' }),
};

export const users = {
  list: () => API.get('/api/users'),
  create: (data) => API.post('/api/users', data),
  update: (id, data) => API.put(`/api/users/${id}`, data),
  updateLanguage: (language) => API.patch('/api/settings/language', { language }),
};

export const dashboard = { stats: () => API.get('/api/dashboard/stats') };

export const getWsUrl = (sessionId, params) => {
  const base = BASE.replace('https://', 'wss://').replace('http://', 'ws://');
  return `${base}/ws/download/${sessionId}?${new URLSearchParams(params).toString()}`;
};

export default API;
